import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CadastroService } from '../../../../../services/cadastro.service';
import { HistoricoPreco } from '../../../../../models/cadastro.model';
import { ActivatedRoute, Router } from '@angular/router';
import { todayLocalDateString } from '../../../../../core/utils/date.util';

@Component({
  selector: 'app-produtos-historico-precos',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './produtos-historico-precos.component.html',
  styleUrl: './produtos-historico-precos.component.css',
})
export class ProdutosHistoricoPrecosComponent implements OnInit {

  private readonly cadastroService = inject(CadastroService);
  private readonly fb = inject(FormBuilder);
  private produtoId!: number;
  protected precoSugerido: number = 0.00;

  form!: FormGroup;
  historico: HistoricoPreco[] = [];
  paginatedHistorico: HistoricoPreco[] = [];
  
  currentPage = 1;
  pageSize = 5;
  totalPages = 0;


constructor(
  private route: ActivatedRoute,
  private router: Router
) { }
  


  ngOnInit(): void {
  
    this.form = this.fb.group({
      precoCusto: [null, [Validators.required, Validators.min(0)]],
      precoVenda: [null, [Validators.required, Validators.min(0)]],
      custoFrete: [null, [Validators.min(0)]],
      dataInicio: [todayLocalDateString(), Validators.required]
    });
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {

        this.produtoId = +id;
        this.loadHistorico();
      }
    });
  }

  loadHistorico() {
    this.cadastroService.getHistoricoPrecos(this.produtoId).subscribe(data => {
      this.historico = data;
      this.totalPages = Math.ceil(this.historico.length / this.pageSize);
      this.goToPage(1);
    });
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedHistorico = this.historico.slice(startIndex, endIndex);
  }

  calcularPrecoSugerido(){
    const precoCusto = this.form.get('precoCusto')?.value;
    const custoFrete = this.form.get('custoFrete')?.value;
    if (precoCusto && custoFrete) {
      this.precoSugerido =  (precoCusto + custoFrete) * 3;
    }
  }

  salvar() {
    if (this.form.valid) {
      const novoHistorico: HistoricoPreco = {
        ...this.form.value,
        produtoId: this.produtoId,
      };

      this.cadastroService.createHistoricoPrecos(novoHistorico).subscribe(() => {
        this.loadHistorico();
        this.form.reset({
          dataInicio: todayLocalDateString()
        });
      });
    }
  }

  voltar(): void {
      this.router.navigate(['/home', 'produto-cadastro']);
  }
}
